import { HubOverview } from '../models';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

export class HubItemSetId {
  public static readonly type = '[HubItem] Set Base Data';

  constructor(public payload: number) {}
}

export class HubItemCreate {
  public static readonly type = '[HubItem] Create Hub';

  constructor(public payload: HubOverview) {}
}

export class HubItemNewSsccId {
  public static readonly type = '[HubItem] Get new ssccId';
}

export class HubItemChangeActiveState {
  public static readonly type = '[HubItem] Change Hub active state ';

  constructor(public payload: { enable: boolean; hubId: number }) {}
}

export class HubItemDelete {
  public static readonly type = '[HubItem] Delete Hub';

  constructor(public payload: { dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>; hubId: number }) {}
}

export class HubItemInitialState {
  public static readonly type = '[HubItem] Set initial state';
}
